import { Button } from "antd"
import styles from "@/styles/view-cart.module.scss"

const CartInfoLinks = () => (
  <div className={styles['scinformation']}>
    <Button type="link" href="/article/DeliveryBrand" className={styles['scinformation-item']}>Shipping Information</Button>
    <Button type="link" href="/article/TermsAndConditions#return" className={styles['scinformation-item']}>Return Policy</Button>
    <Button type="link" href="/article/PrivacyStatement" className={styles['scinformation-item']}>Your Privacy & Security</Button>
  </div>
)

export default CartInfoLinks
